// Exported from the last version prior to 1.5. 
import StaticScreenPositions from "../StaticScreenPositions";
import MusicPlayTimes from "../../data/MusicPlayTimes";

const romBase = 0x013;

const RomData = {
    romUrl: window.isSoloApp ? 
        '/latest-rom.nes' :
        'https://s3.amazonaws.com/cpprograms-nes-games-https/retro-puzzle-maker-v5-3.nes?r=1',
    smallRomUrl: window.isSoloApp ? '/latest-rom-compressed.nes' : 
        'https://s3.amazonaws.com/cpprograms-nes-games-https/retro-puzzle-maker-compressed-v5-3.nes?r=1',
    testMessageText: 'PATCH TARGET 1.02',
    testMessagePosition: romBase,
};

function gameLevelDataFormat(data, game) {
    let realData = [];

    data.forEach(level => {
        for (let i = 0; i < 60; i++) {
            realData.push((level.tiles[i<<1] << 4) + level.tiles[((i<<1)+1)]);
        }
        realData.push(level.borderTile);
        // Grab the default game's gamestyle if a gamestyle isn't written into the current level
        realData.push(level.style === null ? game.defaultLevelStyle : level.style);
        realData.push(level.startPosition);
        realData.push(0);
    });

    return realData;
}

function tileDataPaletteFormat(vals) {
    return vals.map(a => a.palette);
}

function tileDataCollisionFormat(vals) {
    return vals.map(a => a.collision);
}

function formatScreens(vals, game) {
    let data = [];
    let i = 0;
    for (; i < vals.length; i++) {
        vals[i].data.forEach(d => data.push(d));
    }
    for (; i < (game.smallRom ? 8 : 14); i++) {
        for (let j = 0; j < 1024; j++) {
            data.push(0);
        }
    }
    return data;
}

function formatScreenTypes(vals) {
    let screenTypes = [];
    console.info('mobx is about to show some warnings about out of bounds index reads, they are safe to ignore!');
    for (let i = 0; i < 16; i++) {
        let value = vals[i]?.showAt ?? 255;
        if (value === StaticScreenPositions.AfterLevel) {
            value += vals[i].showAtDetail;
        } else if (value === StaticScreenPositions.AfterScreen) {
            value += vals.findIndex(a => a.id === vals[i].showAtDetail);
        }
        screenTypes.push(value);
    }
    return screenTypes;
}

function getValForSongId(game, id) {
    if (game.creditsSong === id) {
        return MusicPlayTimes.OnEndScreen;
    } else if (game.gameplaySong === id) {
        return MusicPlayTimes.OnLevel;
    } else if (game.titleSong === id) {
        return MusicPlayTimes.OnTitle;
    } else {
        return 255;
    }
}

function customSongShowTimesFormatter(vals, game) {
    if (game.usingBuiltInMusic) {
        let musicData = [];
        for (let i = 0; i < 16; i++) {
            musicData.push(getValForSongId(game, i));
        }
        return musicData;
    } else {
        let musicData = [];
        for (let i = 0; i < 16; i++) {
            if (i < game.customSongCount) {
                let value = vals[i]?.showAt ?? 255;
                if (value === MusicPlayTimes.OnLevel) {
                    value += vals[i].showAtDetail;
                } else if (value === MusicPlayTimes.OnScreen) { 
                    console.info('css formatter', value, vals[i], game.staticScreens.findIndex(s => s.id === vals[i].showAtDetail), game.staticScreens)
                    value += game.staticScreens.findIndex(s => s.id === vals[i].showAtDetail);
                }
                musicData.push(value);
            } else {
                musicData.push(255);
            }
        }
        return musicData;
    }
}

RomData.patches = [
    // +1 because of the \n at the end of a .asciiz
    {name: 'title', symbol: '_gameName', address: romBase + RomData.testMessageText.length + 1, length: 29, padText: true, padBinary: false},
    {name: 'lastLevel', symbol: '_totalGameLevels', length: false, dataFormatter: a => a+1},
    {name: 'levels', symbol: '_gameLevelData', length: 4096, dataFormatter: gameLevelDataFormat},
    {name: 'tileData', symbol: '_tileCollisionTypes', length: 16, dataFormatter: tileDataCollisionFormat},
    {name: 'tileData', symbol: '_tilePalettes', length: 16, dataFormatter: tileDataPaletteFormat},
    {name: 'titleScreenData', symbol: '_titleScreenData', length: 0x400},
    {name: 'creditsScreenData', symbol: '_creditsScreenData', length: 0x400},
    {name: 'gamePaletteData', symbol: '_gamePaletteData', length: 16},
    {name: 'spritePalette', symbol: '_spritePalette', length: 4},
    {name: 'unusedByte', symbol: '_unusedByte1', length: false, dataFormatter: () => 255},
    {name: 'singleLevelOverride', symbol: '_singleLevelOverride', length: false, dataFormatter: () => 255},
    {name: 'unusedByte', symbol: '_unusedByte2', length: false, dataFormatter: () => 255},
    {name: 'unusedByte', symbol: '_unusedByte3', length: false, dataFormatter: () => 255},
    {name: 'unusedByte', symbol: '_unusedByte4', length: false, dataFormatter: () => 255},
    {name: 'playerSpeed', symbol: '_movementSpeed', length: false},
    {name: 'coinsCollectedText', symbol: '_coinsCollectedText', length: 20},
    {name: 'cratesRemovedText', symbol: '_cratesRemovedText', length: 20},
    {name: 'undoEnabled', symbol: '_enableUndo', length: false},
    {name: 'showLevelEnabled', symbol: '_enableLevelShow', length: false},
    {name: 'showKeyCount', symbol: '_enableKeyCount', length: false},
    {name: 'showGameTitle', symbol: '_showGameTitle', length: false},
    {name: 'showGoal', symbol: '_showGoal', length: false},
    {name: 'hudData', symbol: '_hudData', length: 192},
    {name: 'hudData', symbol: '_hudDataAttrs', length: 16, dataFormatter: d => d.slice(0x3c0, 0x3d0)},
    {name: 'customSongUsage', symbol: '_customSongShowTimes', length: 16, dataFormatter: customSongShowTimesFormatter},

    {name: 'gameGraphicsData', symbol: '', excludeSymbol: true, address: 0x8013, length: 4096},
    {name: 'soundtrackData', symbol: '', excludeSymbol: true, address: 0x10013, smallRomAddress: 0x04013, length: 10240, smallRomLength: 6144, padBinary: true},
    {name: 'staticScreens', symbol: '_staticScreenTypes', address: 0x14013, smallRomAddress: 0x1A23, length: 16, swapBank: 'STATIC_SC', dataFormatter: formatScreenTypes},
    {name: 'staticScreens', symbol: '_staticScreens', address: 0x14023, smallRomAddress: 0x1A33, length: 1024*14, smallRomLength: 1024*8, padBinary: true, dataFormatter: formatScreens}

];

RomData.patches.forEach((v, idx, array) => {
    if (v.address) {
        if (!v.smallRomAddress) {
            v.smallRomAddress = v.address;
        }
        return;
    }
    const pastRes = array[idx - 1],
        len = pastRes.length === false ? 1 : pastRes.length;

    v.address = pastRes.address + len;
    v.smallRomAddress = pastRes.smallRomAddress + len
});
export default RomData;